import { ensureState } from 'redux-optimistic-ui';
import type { IssueParentsOrderState } from '../../reducers/entities/issue-parent-order/types.tsx';
import type { EntitiesState } from '../../reducers/entities/types.tsx';
import type { State } from '../../types.tsx';

export const getEntities = (state: State): EntitiesState => ensureState(state.entities);
export const getIssueParentsOrderIds = (state: State): IssueParentsOrderState =>
	getEntities(state).issueParentsOrder;
